import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'
import { applyWonderpathDocumentTab, getInitialLanguage } from './contexts/LanguageContext'

/** Runs before React paint so Cursor / Simple Browser tab title + icon update even if index.html was cached. */
applyWonderpathDocumentTab(getInitialLanguage())

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
